// extracted by mini-css-extract-plugin
export default {"container":"infoPanel_container__L27+C","sparse":"infoPanel_sparse__rNbsX"};